const project_description_for_console = function () {
  console.group("About Boom_fx");
  console.log(`Boom_fx, by Stephen Boyd  
July, 2022  
Little India, Toronto, Canada.

fxhash: ${fxhash}
On this date: ${window.$fxhashFeatures["On this date"]}
Aspect Ratio: ${window.$fxhashFeatures["Aspect Ratio"]}
Colour Palette: ${window.$fxhashFeatures["Colour Palette"]}
Concurrent minutes sampled during this day: ${window.$fxhashFeatures["Concurrent minutes sampled during this day"]}`);

  console.group("Project Description");
  console.log(`During the short history of fxhash, there have been several important dates marking the growth and evolution of the platform. Boom_fx is a visual interpretation of ten of these days through the lens of real world earthquake data and the colour palettes of Mark Rothko.

Each iteration of Boom_fx represents a window of time on one of these days and expresses the seismic activity that occurred.

These are creative interpretations and while the visual elements and relationships between objects are all based on detailed seismic data from the United States Geological Survey (USGS), they are not meant to be understood as maps.

The ten days were selected for having some significance to the growth and evolution of the fxhash platform and Tezos more broadly.

In chronological order:

1. September 2, 2014 - Tezos White paper released
2. June 30, 2018 - Tezos Initial Release
3. November 6, 2021- Genesis drop on fxhash
4. November 7, 2021 - ciphrd's and punevyr's first drops
5. November 11, 2021 - markknol drops 'SMOLSKULL'
6. December 9, 2021 - zancan drops 'Garden, Monoliths'
7. January 2, 2022 - E0 "The Genesis Drop" of Waiting to be Signed podcast'
8. March 31, 2022 - The Big Burn
9. April 16, 2022 - fxhash 1.0 release
10. March 27, 2022 - Opening day of Art Basel Hong Kong, 2022

There is an eleventh day included: July 18, 2022. This is the last full day of USGS Earthquake data before Boom_fx is published to fxhash.xyz. This date doesn't represent a milestone for the platform, it simply conveys a milestone for the work itself.

The earthquake data comes from the USGS API which very handily provides GeoJSON files. There is further documentation here: ./documentation/Information_about_boom_fx.md. The documentation outlines how this data was collected and the information included in these feeds.`);

  console.groupEnd();

  console.groupCollapsed("Appreciation");
  console.log(`Thank you as always to the fxhash community and everyone on the Discord who has helped with technical questions and information about significant dates in fxhash's short history.

In particular, Liam Egan, ozzie and willpop.tez were helpful with suggestions on the Discord thread where I asked for input on the first six dates I had selected.  
https://discord.com/channels/900333075509149767/996098227269021876

Thank you to Christopher Berry, @cjpberry, for assistance early on about clustering algorithms.

Thank you to the USGS for making this data available.

And none of this is possible without my family. Thank you the most to KIRH.`);
  console.groupEnd();

  console.groupCollapsed("Keyboard Controls - Exporting to PNG");
  console.log(`Export to a PNG format at several different sizes.

I've added code that will re-render the iteration at each of the sizes listed below while retaining its exact characteristics. This is considerably better than trying to up or downscale an image.

- Press t: thumbnail @ a maximum pixel width or height of 200px
- Press s: your current screen size
- Press p: print size @ a maximum pixel width or height of 4800px which is 16"@300dpi
- Press h: HD4K on the vertical @ a maximum pixel width or height of 2160px
- Press m: Max size @ a maximum pixel width or height of 10800px. This is a biiiig size

The filename will include some metadata such as the unique hash, date and time at time of capture.`);
  console.groupEnd();

  console.groupCollapsed(
    `Software Libraries and other technology used for development`
  );
  console.log(`Software Libraries:
Made with Processing / P5.js  
p5.js v1.4.1 February 02, 2022

Hardware used for development:
MacBook Pro (13-inch, 2019)

Version Control:
https://github.com/sspboyd/boom

This repo is private as of July 2022. However, I have provided a source map with this project so please feel free to browse the code and see how it all works. There are a number of comments in the code explaining what is happening at different points.`);

  console.groupEnd();
  console.groupCollapsed(`Tags`);
  console.log(
    `Boom_fx, USGS, generative, code, geometry, geometric, generativeart, processing, p5js, 2d, abstract, colour, color, math, maths, cryptoart, substrate, sspboyd, Stephen_Boyd, fxhash, IPFS, Boom_01`
  );
  console.groupEnd();

  console.group(`License information`);
  console.log(`See LICENSE.md
This work is licensed under a Creative Commons
Attribution-NonCommercial-NoDerivatives 4.0 International License
http://creativecommons.org/licenses/by-nc-nd/4.0/

NFT Art and Code copyright Stephen Boyd`);
  console.groupEnd();
  console.groupCollapsed("About Stephen Boyd");
  console.log(`I live and work in the community of Little India in Toronto, Ontario, Canada.

I've been working with Processing and now P5.js to create generative art since 2004.

I am drawn to projects where I can use data as a substrate for expressing the details and relationships within the data.

My process is to sketch ideas to paper first as logic statements combined with visual relationships and then build the code up from there. I typically don't know what the visual outputs will become before the first test render.

I'm self-taught (no formal art or comp sci education) so I can proudly claim all mistakes are mine alone.

In my experience, the best outputs come from the first buggy renders before I can get in there to tweak and 'fix' things.

Find me online @sspboyd. Please say hi!

- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- GitHub, https://github.com/sspboyd
- Twitter, https://twitter.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Twitch.tv, https://www.twitch.tv/sspboyd
- Email: stephen@sspboyd.ca`);
  console.groupEnd();
  console.groupCollapsed("Contact Info");
  console.log(`- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- GitHub, https://github.com/sspboyd
- Twitter, https://twitter.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Twitch.tv, https://www.twitch.tv/sspboyd
- Email: stephen@sspboyd.ca
`);
  console.groupEnd("Contact Info");

  console.groupEnd();
};

export { project_description_for_console };
